<div class="menubar-hoverable header-fixed menubar-pin cv2">

  <!-- header -->
  <!--  -->
  <!-- BEGIN BASE-->
  <div id="base">
    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div><!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->
    <!-- BEGIN CONTENT-->
    <div id="content">
      <section class="has-actions style-default-bright cv2-section fv2-section">
        <div class="fv2-page-head">
          <div class="fv2-tabs cv2-slider" role="tablist" aria-label="Class Management Sections">
            <span class="fv2-tab-indicator cv2-slide-indicator" aria-hidden="true"></span>
            <button type="button" class="fv2-tab" data-target="#tab-categories" data-toggle="tab" *ngIf="permissions.ADD_CATEGORY == 'ENABLED' || permissions.VIEW_CATEGORY == 'ENABLED'" [class.active]="activeTab === 'categories'" role="tab" (click)="setActive('categories')"><span class="tab-categories tab-text">{{ 'categories' | translate }}</span></button>
            <button type="button" class="fv2-tab" data-target="#tab-classes" data-toggle="tab" *ngIf="permissions.ADD_CLASS_STANDARDS == 'ENABLED' || permissions.CLASS_STANDARD == 'ENABLED'" [class.active]="activeTab === 'classes'" role="tab" (click)="setActive('classes')"><span class="tab-classes tab-text">{{ 'classStandards' | translate }}</span></button>
            <button type="button" class="fv2-tab" data-target="#tab-subjects" data-toggle="tab" *ngIf="permissions.ADD_SUBJECT == 'ENABLED' || permissions.VIEW_SUBJECTS == 'ENABLED'" [class.active]="activeTab === 'subjects'" role="tab" (click)="setActive('subjects')"><span class="tab-subjects tab-text">{{ 'subjects' | translate }}</span></button>
            <button type="button" class="fv2-tab" data-target="#tab-timetable" data-toggle="tab" *ngIf="permissions.TIME_TABLE_MANAGEMENT == 'ENABLED'" [class.active]="activeTab === 'timetable'" role="tab" (click)="setActive('timetable'); editButtonHide()"><span class="tab-timetable tab-text">{{ 'timeTable' | translate }}</span></button>
            <button type="button" class="fv2-tab" data-target="#tab-attendance" data-toggle="tab" [class.active]="activeTab === 'attendance'" role="tab" (click)="setActive('attendance'); handleAttendanceDetails()"><span class="tab-attendance tab-text">{{ 'attendance' | translate }}</span></button>
          </div>
        </div>
        <div class="fv2-stats cv2-stats">
          <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-teal"><i class="ph ph-squares-four"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'cv2TotalCategories' | translate }}</span><span class="cv2-skel cv2-skel-num" *ngIf="loading('schoolClassManagementGetCategoryList')"></span><b class="fv2-num" *ngIf="!loading('schoolClassManagementGetCategoryList')">{{ getCategoryListArray.length }}</b></div></div>
          <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-sky"><i class="ph ph-chalkboard-teacher"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'cv2TotalClasses' | translate }}</span><span class="cv2-skel cv2-skel-num" *ngIf="loading('schoolClassManagementGetCategoryList','groupsStudentAcademicList','schoolClassManagementGetClassList')"></span><b class="fv2-num" *ngIf="!loading('schoolClassManagementGetCategoryList','groupsStudentAcademicList','schoolClassManagementGetClassList')">{{ getClassListArray.length }}</b></div></div>
          <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-maple"><i class="ph ph-book-open"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'cv2TotalSubjects' | translate }}</span><span class="cv2-skel cv2-skel-num" *ngIf="loading('schoolClassManagementGetSubjectList')"></span><b class="fv2-num" *ngIf="!loading('schoolClassManagementGetSubjectList')">{{ getSubjectListArray.length }}</b></div></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="">
              <div class="card-head cv2-tabs-head" style="display:none"></div>
              <div class="card-body tab-content" style="padding: 0;">
                <!-- CATEGORIES -->
                <div class="tab-pane" [ngClass]="{'active': activeTab === 'categories'}" id="tab-categories">
                  <div class="fv2-panel">
                    <div class="fv2-details-head">
                      <h3>{{ 'categories' | translate }}</h3>
                      <button [style.display]="permissions.ADD_CATEGORY == 'ENABLED' ? '':'none'" type="button" class="fv2-btn-primary"
                        data-toggle="modal" data-target="#add-new-categories" (click)="clearAddCatData()"><i class="ph ph-plus"></i><span>{{ 'addNew' | translate }}</span></button>
                    </div>
                    <div class="cv2-toolbar">
                      <div class="cv2-search">
                        <i class="ph ph-magnifying-glass"></i>
                        <input type="text" class="fv2-field-input" [(ngModel)]="catTable.search" (ngModelChange)="catTable.onSearch()" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
                      </div>
                      <select class="fv2-field-input cv2-size" [(ngModel)]="catTable.size" (ngModelChange)="catTable.onSize()" [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let n of catTable.sizes" [ngValue]="n">{{ n }}</option>
                      </select>
                    </div>
                    <div class="fv2-wrap">
                      <table id="cv2-category-table" class="fv2-table">
                        <thead><tr><th class="fv2-th-sort" (click)="catTable.sort('CategoryName')">{{ 'categoryName' | translate }} <i class="ph" *ngIf="catTable.sortKey === 'CategoryName'" [ngClass]="catTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="catTable.sort('TotalClasses')">{{ 'cv2TotalClasses' | translate }} <i class="ph" *ngIf="catTable.sortKey === 'TotalClasses'" [ngClass]="catTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="catTable.sort('TotalSections')">{{ 'cv2TotalSections' | translate }} <i class="ph" *ngIf="catTable.sortKey === 'TotalSections'" [ngClass]="catTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="catTable.sort('TotalStudent')">{{ 'cv2Students' | translate }} <i class="ph" *ngIf="catTable.sortKey === 'TotalStudent'" [ngClass]="catTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th></tr></thead>
                        <tbody>
                          <ng-container *ngIf="loading('schoolClassManagementGetCategoryList')"><tr class="cv2-skel-row" *ngFor="let _r of skel(6)"><td *ngFor="let _c of skel(4)"><span class="cv2-skel"></span></td></tr></ng-container>
                          <tr *ngIf="getCategoryListArray.length === 0 && !loading('schoolClassManagementGetCategoryList')"><td colspan="4" class="cv2-empty-cell">{{ 'cv2NoCategories' | translate }}</td></tr>
                          <tr *ngIf="getCategoryListArray.length > 0 && catTable.filtered.length === 0 && !loading('schoolClassManagementGetCategoryList')"><td colspan="4" class="cv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                          <tr *ngFor="let category of view(catTable, getCategoryListArray)" [rowEntrance]="category" class="cv2-click-row"
                            (click)="classDetailView(catname.innerText,ttclasses.innerText,ttsections.innerText,ttstudents.innerText,category)">
                            <td #catname class="fv2-money">{{category.CategoryName}}</td>
                            <td #ttclasses>{{category.TotalClasses}} {{ 'classes' | translate }}</td>
                            <td #ttsections>{{category.TotalSections}} {{ 'sections' | translate }}</td>
                            <td #ttstudents>{{category.TotalStudent}} {{ 'students' | translate }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="cv2-pager" *ngIf="catTable.filtered.length > 0">
                      <span class="cv2-pager-info">{{ catTable.filtered.length }} {{ 'total' | translate }}</span>
                      <div class="cv2-pager-btns">
                        <button type="button" class="fv2-btn-ghost" [disabled]="catTable.page <= 1" (click)="catTable.go(catTable.page - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
                        <b>{{ catTable.page }} / {{ catTable.pages }}</b>
                        <button type="button" class="fv2-btn-ghost" [disabled]="catTable.page >= catTable.pages" (click)="catTable.go(catTable.page + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End CATEGORIES -->

                <!-- CLASSES -->
                <div class="tab-pane" id="tab-classes">
                  <div id="classList">
                    <div class="fv2-panel" [style.display]="enableClassSequence ? 'none' : ''">
                      <div class="fv2-details-head">
                        <h3>{{ 'classStandards' | translate }}</h3>
                        <div class="cv2-head-actions">
                          <button [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'" type="button" class="fv2-btn-ghost"
                            (click)="initiateOrderClassStandards()"><i class="ph ph-sort-ascending"></i><span>{{ 'cv2OrderClasses' | translate }}</span></button>
                          <button [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'" type="button" class="fv2-btn-primary"
                            data-toggle="modal" data-target="#add-new-class" (click)="addNewClassModal()"><i class="ph ph-plus"></i><span>{{ 'addNew' | translate }}</span></button>
                        </div>
                      </div>
                    <div class="cv2-toolbar">
                      <div class="cv2-search">
                        <i class="ph ph-magnifying-glass"></i>
                        <input type="text" class="fv2-field-input" [(ngModel)]="classTable.search" (ngModelChange)="classTable.onSearch()" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
                      </div>
                      <select class="fv2-field-input cv2-size" [(ngModel)]="classTable.size" (ngModelChange)="classTable.onSize()" [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let n of classTable.sizes" [ngValue]="n">{{ n }}</option>
                      </select>
                    </div>
                      <div class="fv2-wrap">
                        <table id="cv2-class-table" class="fv2-table">
                          <thead><tr><th class="fv2-th-sort" (click)="classTable.sort('ClassName')">{{ 'className' | translate }} <i class="ph" *ngIf="classTable.sortKey === 'ClassName'" [ngClass]="classTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="classTable.sort('TotalSection')">{{ 'cv2TotalSections' | translate }} <i class="ph" *ngIf="classTable.sortKey === 'TotalSection'" [ngClass]="classTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="classTable.sort('categoryName')">{{ 'classCategory' | translate }} <i class="ph" *ngIf="classTable.sortKey === 'categoryName'" [ngClass]="classTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="classTable.sort('TotalStudent')">{{ 'cv2Students' | translate }} <i class="ph" *ngIf="classTable.sortKey === 'TotalStudent'" [ngClass]="classTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="classTable.sort('TotalStaff')">{{ 'cv2Staffs' | translate }} <i class="ph" *ngIf="classTable.sortKey === 'TotalStaff'" [ngClass]="classTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th></tr></thead>
                          <tbody>
                            <ng-container *ngIf="loading('schoolClassManagementGetCategoryList','groupsStudentAcademicList','schoolClassManagementGetClassList')"><tr class="cv2-skel-row" *ngFor="let _r of skel(6)"><td *ngFor="let _c of skel(5)"><span class="cv2-skel"></span></td></tr></ng-container>
                            <tr *ngIf="getClassListArray.length === 0 && !loading('schoolClassManagementGetCategoryList','groupsStudentAcademicList','schoolClassManagementGetClassList')"><td colspan="5" class="cv2-empty-cell">{{ 'cv2NoClasses' | translate }}</td></tr>
                            <tr *ngIf="getClassListArray.length > 0 && classTable.filtered.length === 0 && !loading('schoolClassManagementGetCategoryList','groupsStudentAcademicList','schoolClassManagementGetClassList')"><td colspan="5" class="cv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                            <tr class="offcanvas-viewClasses cv2-click-row" [rowEntrance]="class" *ngFor="let class of view(classTable, getClassListArray)"
                              (click)="getclassDetailView(className.innerText,totalSections.innerText,categoryName.innerText,classId.innerText,totalStudents.innerText,totalStaffs.innerText,catId.innerText,classStdId.innerText)">
                              <td #className class="fv2-money">{{class.ClassName}}</td>
                              <td><span #totalSections>{{class.TotalSection}}</span> {{ 'sections' | translate }}</td>
                              <td #categoryName>{{class.categoryName}}</td>
                              <td><span #totalStudents>{{class.TotalStudent}}</span> {{ 'students' | translate }}</td>
                              <td #totalStaffs>{{class.TotalStaff}} {{ 'staffs' | translate }}</td>
                              <span #catId style="display:none">{{class.categoryId}}</span>
                              <span #classId style="display:none">{{class.classId}}</span>
                              <span #classStdId style="display:none">{{class.fkClassStandardsId}}</span>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    <div class="cv2-pager" *ngIf="classTable.filtered.length > 0">
                      <span class="cv2-pager-info">{{ classTable.filtered.length }} {{ 'total' | translate }}</span>
                      <div class="cv2-pager-btns">
                        <button type="button" class="fv2-btn-ghost" [disabled]="classTable.page <= 1" (click)="classTable.go(classTable.page - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
                        <b>{{ classTable.page }} / {{ classTable.pages }}</b>
                        <button type="button" class="fv2-btn-ghost" [disabled]="classTable.page >= classTable.pages" (click)="classTable.go(classTable.page + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" id="classes-Status"
                    style="display: none;height: 100%;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding-top: 15em;">
                    <i class="ph ph-circle-notch fv2-spin" style="font-size:32px;color:var(--brand-primary-color)"></i>
                    <h3 style="color: var(--brand-primary-color);font-size: 1.4em;font-weight: 600;">{{ 'pleaseWait' | translate }}</h3>
                  </div>
                  <div id="updateClassSequenceOrder" *ngIf="enableClassSequence">
                    <div class="col-md-8 text-center">
                      <h3 style="color: var(--brand-primary-color);float: left;">{{ 'updateClassStandardOrder' | translate }}</h3>
                    </div>
                    <!-- <div class="col-md-4 text-right" style="padding-top: 15px;">
                      <button type="button" (click)="enableClassSequence = false" class="fv2-btn-ghost cancelupdateorder">Cancel</button>
                      <button type="button" class="tttttttt fv2-btn-primary" (click)="updateClassOrder()">Save</button>
                    </div> -->
                    <div style="padding: 0px 15px">
                      <table class="fv2-table">
                        <thead>
                          <tr>
                            <th style="padding-left: 10px;">{{ 'sort' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'className' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'totalSections' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'classCategory' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'studentsInThisCategory' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'staffsInThisCategory' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody class="list">
                          <tr *ngFor="let std of getClassListArray; let i=index">
                            <td><input style="width: 30px; height: 30px;text-align: center;" type="text"
                                [(ngModel)]="std.Sequence" (keyup)="validateClassOrder(std, i)" /></td>
                            <td #className>{{std.ClassName}}</td>
                            <td><span #totalSections>{{std.TotalSection}}</span> {{ 'sections' | translate }}</td>
                            <td #categoryName>{{std.categoryName}}</td>
                            <td><span #totalStudents>{{std.TotalStudent}}</span> {{ 'students' | translate }}</td>
                            <td #totalStaffs>{{std.TotalStaff}} {{ 'staffs' | translate }}</td>
                            <span #sequence style="display:none">{{std.Sequence}}</span>
                            <span class="classId" #classId style="display:none">{{std.classId}}</span>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12 text-right" style="padding: 15px 15px;">
                      <button type="button" (click)="enableClassSequence = false"
                        class="fv2-btn-ghost cancelupdateorder">{{ 'cancel' | translate }}</button>
                      <button type="button" class="tttttttt fv2-btn-primary"
                        (click)="updateClassOrder()">{{ 'save' | translate }}</button>
                    </div>
                  </div>
                </div>
                <!-- End CLASSES -->

                <!-- SUBJETS -->
                <div class="tab-pane" id="tab-subjects">
                  <div class="fv2-panel">
                    <div class="fv2-details-head">
                      <h3>{{ 'subjects' | translate }}</h3>
                      <div [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'" id="addSubjectNew">
                        <button id="addSubjectButton" type="button" (click)="clearAddSubData()" class="fv2-btn-primary"><i class="ph ph-plus"></i><span>{{ 'addNew' | translate }}</span></button>
                      </div>
                    </div>
                    <div id="add-new-subject" class="cv2-inline-add" style="display: none">
                      <div class="cv2-inline-add-row">
                        <div class="cv2-inline-add-field">
                          <label class="fv2-field-label" for="groupbutton91">{{ 'subjectName' | translate }}</label>
                          <input type="text" class="fv2-field-input" id="groupbutton91" [(ngModel)]="addSub.subjectname" name="addSubject">
                        </div>
                        <button id="addSubButton" class="fv2-btn-primary" type="button" (click)="addNewSubject(addSub)">{{ 'addSubject' | translate }}</button>
                        <button id="canceladdnewSubject" class="fv2-btn-ghost" type="button">{{ 'cancel' | translate }}</button>
                      </div>
                    </div>
                    <div class="cv2-toolbar">
                      <div class="cv2-search">
                        <i class="ph ph-magnifying-glass"></i>
                        <input type="text" class="fv2-field-input" [(ngModel)]="subjectTable.search" (ngModelChange)="subjectTable.onSearch()" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
                      </div>
                      <select class="fv2-field-input cv2-size" [(ngModel)]="subjectTable.size" (ngModelChange)="subjectTable.onSize()" [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let n of subjectTable.sizes" [ngValue]="n">{{ n }}</option>
                      </select>
                    </div>
                    <div class="fv2-wrap">
                      <table id="cv2-subject-table" class="fv2-table">
                        <thead><tr><th class="fv2-th-sort" (click)="subjectTable.sort('subject')">{{ 'subjectName' | translate }} <i class="ph" *ngIf="subjectTable.sortKey === 'subject'" [ngClass]="subjectTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="subjectTable.sort('belongingClasses')">{{ 'cv2Classes' | translate }} <i class="ph" *ngIf="subjectTable.sortKey === 'belongingClasses'" [ngClass]="subjectTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th></tr></thead>
                        <tbody>
                          <ng-container *ngIf="loading('schoolClassManagementGetSubjectList')"><tr class="cv2-skel-row" *ngFor="let _r of skel(6)"><td *ngFor="let _c of skel(2)"><span class="cv2-skel"></span></td></tr></ng-container>
                          <tr *ngIf="getSubjectListArray.length === 0 && !loading('schoolClassManagementGetSubjectList')"><td colspan="2" class="cv2-empty-cell">{{ 'cv2NoSubjects' | translate }}</td></tr>
                          <tr *ngIf="getSubjectListArray.length > 0 && subjectTable.filtered.length === 0 && !loading('schoolClassManagementGetSubjectList')"><td colspan="2" class="cv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                          <tr class="cv2-click-row" *ngFor="let subjects of view(subjectTable, getSubjectListArray)" [rowEntrance]="subjects"
                            (click)="getsubjectDetailView(subjectName.innerText,subjectId.innerText,subjectBelonging.innerText)">
                            <td #subjectName class="fv2-money">{{subjects.subject}}</td>
                            <td #subjectBelonging>{{subjects.belongingClasses}} {{ 'classes' | translate }}</td>
                            <span #subjectId style="display:none">{{subjects.subjectId}}</span>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="cv2-pager" *ngIf="subjectTable.filtered.length > 0">
                      <span class="cv2-pager-info">{{ subjectTable.filtered.length }} {{ 'total' | translate }}</span>
                      <div class="cv2-pager-btns">
                        <button type="button" class="fv2-btn-ghost" [disabled]="subjectTable.page <= 1" (click)="subjectTable.go(subjectTable.page - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
                        <b>{{ subjectTable.page }} / {{ subjectTable.pages }}</b>
                        <button type="button" class="fv2-btn-ghost" [disabled]="subjectTable.page >= subjectTable.pages" (click)="subjectTable.go(subjectTable.page + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End SUBJETS -->

                <!-- TIMETABLE -->
                <div class="tab-pane" id="tab-timetable">
                  <div class="card-body">
                    <div id="timetableslots">
                      <div class="fv2-panel cv2-tt-panel">
                      <div class="fv2-details-head"><h3>{{ 'timeTable' | translate }}</h3></div>
                      <form class="cv2-tt-form search-groups" autocomplete="off">
                        <div class="cv2-tt-field">
                          <label class="fv2-field-label" for="select15">{{ 'class' | translate }}</label>
                          <select id="select15" name="select13" class="fv2-field-input"
                            (change)="getSectionListClassView($event.target.value)">
                            <option value="0">{{ 'selectClass' | translate }}</option>
                            <option *ngFor="let class of getClassListArray" value="{{class.fkClassStandardsId}}">{{class.ClassName}}</option>
                          </select>
                        </div>
                        <div class="cv2-tt-field">
                          <label class="fv2-field-label" for="sectionOfClass">{{ 'section' | translate }}</label>
                          <select id="sectionOfClass" name="select13" class="fv2-field-input">
                            <option value="0">{{ 'selectSection' | translate }}</option>
                            <option *ngFor="let section of getClassViewClassSectionArray" value="{{section.claaSectionId}}">{{section.className}} - {{section.classSection}}</option>
                          </select>
                        </div>
                        <div class="cv2-tt-actions">
                          <button type="button" id="select-class-time" class="fv2-btn-primary"
                            (click)="ViewClassTimetable();getTimetable(classStdSectionId)"><i class="ph ph-eye"></i><span>{{ 'view' | translate }}</span></button>
                          <button type="button" id="addTimeTable" class="fv2-btn-ghost" (click)="getClassCategories()"><i class="ph ph-gear"></i><span>{{ 'configure' | translate }}</span></button>
                          <input (click)="editTimeTable()" type="button" [attr.value]="'edit' | translate" id="edit-timetable" class="fv2-btn-ghost" />
                          <input (click)="cancelEditButton()" type="button" [attr.value]="'cancel' | translate" id="cancel-edit-timetable" class="fv2-btn-ghost edit-time-table hide" />
                          <input (click)="saveTimeTable()" type="button" id="savettforupadte" [attr.value]="'save' | translate" class="fv2-btn-primary" />
                        </div>
                      </form>
                      </div>
                      <div class="col-md-12 text-right" style="padding: 10px 12px;">
                        <span class="tag label label-info" id="msghide" style="float: left;margin-top: 17px;">{{ 'pleasePressEscapeButtonToClearCopy' | translate }}</span>
                      </div>
                      <div class="time-table-information col-md-12">
                        <!--<h3 class="class-teacher-info">Time Table</h3>-->
                        <div class="cv2-skel-block cv2-tt-skel" *ngIf="loading('fetchSubjectOfClass','fetchTimeTableOfClass')">
                          <div class="cv2-skel cv2-skel-line"></div>
                          <div class="cv2-skel cv2-skel-grid"><span class="cv2-skel" *ngFor="let _c of skel(18)"></span></div>
                        </div>
                        <div class="table-responsive time-table-inner-container-info" [style.display]="loading('fetchSubjectOfClass','fetchTimeTableOfClass') ? 'none' : ''">
                          <!--<select id="select-class-time" class="select-class-info-details">
                            <option>Select Class</option>
                          </select>-->






                          <!--input(type="button",value='Print',class='btn btn-raised btn-primary' id='print-timetable' style='float:right')-->

                          <table id="timetable" class="table table-bordered text-center timetable-view">
                            <thead class="header-in-table" style="background: #dadada;">
                              <tr>
                                <th class="class-teacher-info text-center">{{ 'periodDay' | translate }}</th>
                                <th id="timetablethday1" class="class-teacher-info text-center">{{ 'monday' | translate }}</th>
                                <th id="timetablethday2" class="class-teacher-info text-center">{{ 'tuesday' | translate }}</th>
                                <th id="timetablethday3" class="class-teacher-info text-center">{{ 'wednesday' | translate }}</th>
                                <th id="timetablethday4" class="class-teacher-info text-center">{{ 'thursday' | translate }}</th>
                                <th id="timetablethday5" class="class-teacher-info text-center">{{ 'friday' | translate }}</th>
                                <th id="timetablethday6" class="class-teacher-info text-center">{{ 'saturday' | translate }}</th>
                                <th id="timetablethday7" class="class-teacher-info text-center">{{ 'sunday' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="active">
                                <td colspan="8">{{ 'selectClassToViewTimetable' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div name="timetable" class="update-time-table-container-info"
                            style="padding: 2em 0em;float: right;">
                            <button (click)="saveTimeTable()" type="button" value="Save" id="saveTimetable"
                              class="fv2-btn-primary update-timetable-btn">{{ 'save' | translate }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="configureTimeTable" class="fv2-panel cv2-config" style="display: none">
                      <div class="fv2-details-head">
                        <h3><i class="ph ph-clock"></i> {{ 'configureTimeTable' | translate }}</h3>
                      </div>
                      <div class="time-table-inner-container cv2-config-body">
                        <div class="time-table-big-container">
                          <div class="cv2-config-grid">
                            <div class="cv2-cfg-field">
                              <label class="fv2-field-label" for="category-info-time-table">{{ 'category' | translate }}</label>
                              <select class="category-selector fv2-field-input" id="category-info-time-table" name="categoryList">
                                <option value="0">{{ 'selectCategory' | translate }}</option>
                                <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">{{category.categoryName}}</option>
                              </select>
                            </div>
                            <div class="cv2-cfg-field">
                              <label class="fv2-field-label" for="time-period">{{ 'cv2NumberOfPeriods' | translate }}</label>
                              <input type="text" required="" class="fv2-field-input" id="time-period" name="peroid" maxlength="2">
                            </div>
                          </div>

                          <div class="cv2-config-section">
                            <label class="fv2-field-label">{{ 'cv2WorkingDays' | translate }}</label>
                            <div class="cv2-days">
              <label class="cv2-day"><input class="configDay" type="checkbox" id="monday" day="monday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'monday' | translate }}</span></label>
              <label class="cv2-day"><input class="configDay" type="checkbox" id="tuesday" day="tuesday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'tuesday' | translate }}</span></label>
              <label class="cv2-day"><input class="configDay" type="checkbox" id="wednesday" day="wednesday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'wednesday' | translate }}</span></label>
              <label class="cv2-day"><input class="configDay" type="checkbox" id="thursday" day="thursday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'thursday' | translate }}</span></label>
              <label class="cv2-day"><input class="configDay" type="checkbox" id="friday" day="friday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'friday' | translate }}</span></label>
              <label class="cv2-day"><input class="configDay" type="checkbox" id="saturday" day="saturday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'saturday' | translate }}</span></label>
              <label class="cv2-day"><input class="configDay" type="checkbox" id="sunday" day="sunday" name="days"><span class="cv2-day-box"><i class="ph-bold ph-check"></i></span><span>{{ 'sunday' | translate }}</span></label>
                            </div>
                          </div>

                          <div class="time-table-container-for-period-timeand-lunch-time cv2-config-grid cv2-config-grid-3">
                            <div class="cv2-cfg-field">
                              <label class="fv2-field-label" for="class-duration">{{ 'cv2ClassDuration' | translate }}</label>
                              <input class="fv2-field-input" type="text" required="" id="class-duration" name="classDuration">
                            </div>
                            <div class="cv2-cfg-field">
                              <label class="fv2-field-label" for="break-duration">{{ 'cv2BreakDuration' | translate }}</label>
                              <input class="fv2-field-input" type="text" required="" id="break-duration" name="breakDuration">
                            </div>
                            <div class="cv2-cfg-field">
                              <label class="fv2-field-label" for="lunch-duration">{{ 'cv2LunchDuration' | translate }}</label>
                              <input class="fv2-field-input" type="text" required="" id="lunch-duration" name="lunchDuration">
                            </div>
                          </div>

                          <div class="time-table-container cv2-periods" id="timeOfperied"></div>

                          <div class="update-time-table-container cv2-config-foot">
                            <button type="button" id="cancelTimeTable" class="fv2-btn-ghost">{{ 'cancel' | translate }}</button>
                            <button type="button" class="fv2-btn-primary" action="create" id="saveTimetableConfig">{{ 'save' | translate }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End TIMETABLE -->

                <!-- ATTENDANCE -->

                <div class="tab-pane attendance-card" id="tab-attendance">
                  <div class="attendance-container" *ngIf="!loader && classAttendanceDetails.length > 0">
                    <div class="search-container" [class.active]="isSearchActive || searchValue">
                      <div class="search-image">
                        <img src="../../assets/img/search.svg" alt="search-icon" />
                      </div>
                      <input type="text" class="search-box" [placeholder]="'search' | translate" [(ngModel)]="searchValue"
                        (blur)="handelOnBlurSearch()" (input)="filterClassDetailsData()" maxlength="50" />
                    </div>
                    <div class="attendance-config">
                      <span class="config-label">{{'attendanceConfiguration' | translate}}</span>
                      <div class="config-toggle">
                        <button type="button" class="toggle-option"
                          [ngClass]="{'global-attendance-Active':(globalAttendanceConfigurationStatusData === 'DAY' || globalAttendanceConfigurationStatusData === 'MIXED')}"
                          id="day" (click)="handleGlobalAttendanceConfig('DAY')">
                          {{'day' | translate}}
                        </button>
                        <button type="button" class="toggle-option"
                          [ngClass]="{'global-attendance-Active':globalAttendanceConfigurationStatusData === 'PERIOD'}"
                          id="period" (click)="handleGlobalAttendanceConfig('PERIOD')">
                          {{'period' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mixed-type-text"
                    *ngIf="!loader && classAttendanceDetails.length > 0 &&  globalAttendanceConfigurationStatusData ==='MIXED' ">
                    {{'mixedAttendanceConfigurationMessage' | translate}}
                  </div>
                  <div class="attendance-body-card" *ngIf="!loader && filterClassDetails.length > 0 ">
                    <div class="attendance-sub-card" *ngFor="let attendanceDetails of filterClassDetails">
                      <div class="attendance-details">
                        <div class="attendance-class-name" [attr.title]="attendanceDetails.classNumber.length > 15 ? attendanceDetails.classNumber : ''">{{attendanceDetails.classNumber.length > 15 ? attendanceDetails.classNumber.slice(0, 15) + "..." : attendanceDetails.classNumber}} -
                          {{attendanceDetails.classDivision}}</div>
                        <div class="attendance-inside-toggle">
                          <button class="toggle-btn"
                            [ngClass]="{'class-wise-attendance-active':attendanceDetails.attendanceType === 'DAY'}"
                            (click)="handleClassWiseAttendanceConfig(attendanceDetails, 'DAY')"
                            [disabled]="attendanceDetails.dayLoader">
                            <ng-container *ngIf="attendanceDetails.dayLoader; else notLoadingDay">
                              <app-button-loader></app-button-loader>
                            </ng-container>
                            <ng-template #notLoadingDay>
                              {{'day' | translate}}
                            </ng-template>
                          </button>
                          <button class="toggle-btn"
                            [ngClass]="{'class-wise-attendance-active':attendanceDetails.attendanceType === 'PERIOD'}"
                            (click)="handleClassWiseAttendanceConfig(attendanceDetails, 'PERIOD')"
                            [disabled]="attendanceDetails.periodLoader">
                            <ng-container *ngIf="attendanceDetails.periodLoader; else notLoadingPeriod">
                              <app-button-loader></app-button-loader>
                            </ng-container>
                            <ng-template #notLoadingPeriod>
                              {{'period' | translate}}
                            </ng-template>
                          </button>
                        </div>
                      </div>
                      <div class="class-teacher-details">
                        <img src="../../assets/img/teaching.svg" alt="teacher-icon" class="teacher-image"
                          title="Class teacher name" />
                        <span class="teacher-name">{{attendanceDetails.classTeacherName ?
                          attendanceDetails.classTeacherName : ('NA' | translate)}}</span>
                      </div>
                      <div class="class-timetable-details" *ngIf="attendanceDetails.isTimeTableConfigured !== 1">
                        <img src="../../assets/img/alert-circle.svg" alt="alert-icon" class="teacher-image" />
                        <span class="timetable-configuration">{{ attendanceDetails.isTimeTableConfigured !== 1 ?
                          ('timetableNotConfigured'|translate ): '' }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!loader && classAttendanceDetails.length === 0" class="class-not-exist-container">
                    <img src="../../assets/img/details-not-exist.svg" alt="details-not-exist"
                      class="details-not-exist-image" />
                    <p class="details-not-exist-message">{{'classNotAvailableMessage' | translate}}</p>
                  </div>

                  <div class="search-details-not-exist" *ngIf="!loader && filterClassDetails.length === 0 ">
                    {{'classNotExist'| translate}}
                  </div>
                  <div class="attendance-body-card" *ngIf="loader">
                    <div class="cv2-skel cv2-skel-card cv2-skel-att" *ngFor="let _a of skel(6)"></div>
                  </div>
                </div>
                <!-- END ATTENDANCE -->

              </div><!--end .card-body -->
            </div><!--end .card -->
          </div><!--end .col -->
          <!-- END LAYOUT LEFT ALIGNED -->
        </div>

        <!-- Order class standards and sections -->
        <div class="modal fade bd-example-modal-lg cv2-modal" tabindex="-1" role="dialog" id="order-class-standards"
          aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ 'orderClassesSections' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body col-md-12">
                <div class="row col-md-12" style="display: flex;">
                  <div class="col-md-6" data-cv2="cv2-order-col" style="border: 1px solid #E3E6EA; background: #F4F6F9; border-radius: 12px;">
                    <div class="row" style="padding: 5px;text-align: center;font-weight: bold;">{{ 'sortClasses' | translate }}</div>
                    <div class="row">
                      <ul style="padding: 5px;text-align: center;" cdkDropList
                        (cdkDropListDropped)="classDropped($event)" class="list-group cursor-grab">
                        <li (mousedown)="dropListItemMoveStart(class, i)"
                          *ngFor="let class of classesListToDrag; let i=index" cdkDrag class="list-group-item"
                          [ngClass]="{
                          'drag-items': class.isDragging
                        }">
                          <span style="float: left; margin-top: 3px;" class="badge badge-primary">{{i+1}}</span>
                          <span style="text-transform: uppercase;">{{class.ClassName}}</span>
                          <span (click)="initiateSectionDrag(class)" class="btn btn-primary"
                            style="float: right; margin-top: -6px;font-size: unset; text-transform: unset;">
                            <i style="float: right; margin-top: 6px;margin-left: 2px;" class="fa fa-chevron-right"
                              aria-hidden="true"></i>
                            {{ 'orderSections' | translate }}
                          </span>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-primary active" style="float: right;
                      text-transform: unset;
                      margin-right: 5px;margin-bottom: 5px;" (click)="saveClassesOrder(classesListToDrag)">{{ 'saveClassesOrder' | translate }}</button>
                    </div>
                  </div>

                  <div class="col-md-6" data-cv2="cv2-order-col" style="border: 1px solid #E3E6EA; background: #F4F6F9; border-radius: 12px; margin-left: 5px;">
                    <div class="row" style="padding: 5px;text-align: center;font-weight: bold;" id="sortSectionsHead">
                      {{ 'sortSections' | translate }}</div>
                    <div class="row" *ngIf="sectionsListToDrag.length === 0"
                      style="text-align: center;margin-top: 10%;">
                      {{ 'clickOnAny' | translate }} <span class="btn btn-primary"
                        style="font-size: unset; text-transform: unset;pointer-events: none;">
                        <i style="float: right; margin-top: 6px;margin-left: 2px;" class="fa fa-chevron-right"
                          aria-hidden="true"></i>
                        {{ 'orderSections' | translate }}
                      </span> {{ 'toSortSectionsInAClass' | translate }}
                    </div>
                    <div class="row" *ngIf="sectionsListToDrag.length > 0">
                      <ul style="padding: 5px;text-align: center;" cdkDropList
                        (cdkDropListDropped)="classSectionsDropped($event)" class="list-group cursor-grab">
                        <li (mousedown)="dropSectionListItemMoveStart(class,i)"
                          *ngFor="let class of sectionsListToDrag; let i = index" cdkDrag class="list-group-item"
                          [ngClass]="{
                          'drag-items': class.isDragging
                        }">
                          <span style="float: left; margin-top: 3px;" class="badge badge-primary">{{i+1}}</span>
                          <span style="text-transform: uppercase;">{{class.className}} - {{class.classSection}}</span>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-primary active" style="float: right;
                      text-transform: unset;
                      margin-right: 5px;" (click)="saveSectionsOrder(sectionsListToDrag)">{{ 'saveSectionsOrder' | translate }}</button>
                    </div>

                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-primary" (click)="saveClassesOrder(classesListToDrag)">Save changes</button> -->
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'done' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Order class standards and sections End-->

        <!-- Add class modal -->
<div class="modal fade cv2-modal" id="add-new-class" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-buildings"></i></span>{{ 'addStandard' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <form class="form" role="form">
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'standardName' | translate }}</label><input type="text" class="form-control" id="class-name" [(ngModel)]="newStandardName" [ngModelOptions]="{standalone: true}"></div>
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'category' | translate }}</label><select id="select111" name="class lead" class="form-control test1" (change)="selectcategoryAddSection($event.target.value)" [(ngModel)]="selectedCatIdAddSection">
            <option value="0">{{ 'selectCategory' | translate }}</option>
            <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">{{category.categoryName}}</option>
          </select></div>
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'section' | translate }}</label><input #newStandardSections type="text" id="addNewSection" class="form-control" value="" data-role="tagsinput"></div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" id="addstandards" data-dismiss="modal" class="fv2-btn-ghost">{{ 'cancel' | translate }}</button>
        <button type="button" id="stdName" class="fv2-btn-primary" (click)="addNewSection2(newStandardSections.value)">{{ 'add' | translate }}</button>
      </div>
    </div>
  </div>
</div>
        <!--  -->

        <!-- Add timetable -->
        <div class="modal fade" id="add-new-timetable" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" style="min-height: 25em;">
              <div class="col-md-12">
                <div class="col-md-6 text-center"
                  style="background-color: var(--brand-primary-color);color: white;margin-left: -12px;padding: 8.1em 0em;">
                  <i class="fa fa-clock-o fa-4x" aria-hidden="true"></i>
                  <h3>{{ 'addTimetable' | translate }}</h3>
                  <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                </div>
                <div class="col-md-6" style="padding: 25px 0px;">
                  <button
                    style="background-color: var(--brand-primary-color);margin-right: -2.8em;margin-top: -2.8em;float: right;border: none;"
                    type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                    aria-hidden="true">&times;</button>
                  <div class="col-md-8 col-md-offset-1 form-group">
                    <label>{{ 'slotTime' | translate }}</label>
                    <p style="color: #a4b3c5;">{{ 'startTime' | translate }}</p>
                    <input type="text" class="form-control times" name="StartTime"
                      style="margin-top: -50px;margin-left: 75px;font-size: small;color: #a4b3c5;">
                    <p style="margin-top: 25px;color: #a4b3c5;">{{ 'endTime' | translate }}</p>
                    <input type="text" class="form-control times" name="EndTime"
                      style="margin-top: -48px;margin-left: 75px;font-size: small;color: #a4b3c5;">
                  </div>
                  <div class="col-md-10 col-md-offset-1" style="padding: 0px 7px;margin-top: -10px">
                    <form class="form">
                      <div class="form-group">
                        <input type="text" value="Monday,Tuesday,Wednesday,Thursday,Friday" data-role="tagsinput">
                        <label>{{ 'days' | translate }}</label>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-8 col-md-offset-1 form-group">
                    <label>{{ 'subjectName' | translate }}</label>
                    <input type="text" class="form-control" name="addclass" style="margin-top: -2em;margin-left: 5em;">
                  </div>
                  <div class="text-center">
                    <button type="button" class="fv2-btn-primary"
                     >{{ 'add' | translate }}</button>
                    <button type="button" class="fv2-btn-primary"
                     >{{ 'cancel' | translate }}</button>
                  </div>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!--  -->

        <!-- Add categories -->
<div class="modal fade cv2-modal" id="add-new-categories" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-squares-four"></i></span>{{ 'addCategory' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <form class="form" role="form">
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'categoryName' | translate }}</label><input type="text" class="form-control" id="addNewCategoryCategoryName" [(ngModel)]="addNewCategoryCategoryName" [ngModelOptions]="{standalone: true}"></div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" id="addcategory" class="fv2-btn-ghost" data-dismiss="modal">{{ 'cancel' | translate }}</button>
        <button id="addNewCat" type="button" class="fv2-btn-primary" (click)="addNewCategoryCategoryList()">{{ 'add' | translate }}</button>
      </div>
    </div>
  </div>
</div>
        <!--  -->

        <!-- Edit timetable -->
        <div class="modal fade" id="update-timetable" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="width: 75%;">
            <div class="modal-content">
              <div class="modal-header" style="border: none;">
                <button style="border: 1px solid #000000;padding: 1px 5px;outline: none;border-radius: 50%;"
                  type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              </div>
              <div class="modal-body" style="min-height: 12em;">
                <h5>{{ 'editTimetable' | translate }}</h5>
              </div>
              <div class="modal-footer">
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!--  -->

        <!-- Edit new subject -->
<div class="modal fade cv2-modal" id="updateSubject" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-book-open"></i></span>{{ 'updateSubject' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <form class="form" role="form">
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'subjectName' | translate }}</label><input type="text" class="form-control" id="subject" [(ngModel)]="getViewsubjectName" [ngModelOptions]="{standalone: true}" value="{{getSubjectId}}"></div>
        </form>
      </div>
      <div class="modal-footer">
        <button id="closeUpdateSubject" type="button" class="fv2-btn-ghost" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
        <button type="button" id="updateSub" class="fv2-btn-primary" (click)="updateSubjectName()">{{ 'update' | translate }}</button>
      </div>
    </div>
  </div>
</div>
        <!-- Edit Subject -->
      </section>
    </div><!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->
    <!-- Start of OffCanvas -->
    <div class="offcanvas">
      <!-- View categories -->
      <div id="offcanvas-view-class-categories" class="offcanvas-pane width-12"
        style="width:1000px;    overflow-x: hidden;">
<div class="modal fade cv2-modal" id="edit-selected-category-name" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-squares-four"></i></span>{{ 'editCategoryName' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <form class="form" role="form">
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'categoryName' | translate }}</label><input type="text" class="form-control" id="editCategoryCategoryName" [(ngModel)]="editCategoryCategoryName" [ngModelOptions]="{standalone: true}" value="{{getViewCatName}}"></div>
        </form>
      </div>
      <div class="modal-footer">
        <button id="closeUpdateCatPopup" type="button" class="fv2-btn-ghost" data-dismiss="modal">{{ 'cancel' | translate }}</button>
        <button id="upCatName" type="button" class="fv2-btn-primary" (click)="updateCategoryCategoryName()">{{ 'update' | translate }}</button>
      </div>
    </div>
  </div>
</div>
        <div class="offcanvas-head cv2-oc-head" style="padding: 0;">
          <div class="cv2-oc-banner">
            <h3 class="cv2-oc-close" data-dismiss="offcanvas" role="button" aria-label="Close"><i class="ph ph-x"></i></h3>
            <p class="cv2-oc-eyebrow">{{ 'categoryDetails' | translate }}</p>
            <p class="cv2-oc-sub">{{ 'viewSelectedCategoryDetailsHere' | translate }}</p>
            <div class="fv2-stats cv2-oc-facts">
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-teal"><i class="ph ph-identification-card"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'categoryName' | translate }}</span><b class="fv2-num">{{getViewCatName}}</b></div></div>
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-sky"><i class="ph ph-squares-four"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'cv2TotalClasses' | translate }}</span><b class="fv2-num">{{getViewttclasses}}</b></div></div>
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-maple"><i class="ph ph-users-three"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'totalStudents' | translate }}</span><b class="fv2-num">{{getViewttstudents}}</b></div></div>
            </div>
          </div>
          <div class="cv2-oc-bar">
            <h4>{{ 'selectedCategoryDetails' | translate }}</h4>
            <button [style.display]="permissions.ADD_CATEGORY == 'ENABLED' ? '':'none'" data-toggle="modal"
              data-target="#edit-selected-category-name" type="button" class="cv2-icon-btn" aria-label="Edit"><i class="ph ph-note-pencil"></i></button>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div id="dataCategory" class="col-md-12 text-center" style="display: none">
                <h3>{{ 'thereAreNoClassesInThisCategory' | translate }}</h3>
              </div>
              <div id="tablebycategorylist" class="col-md-12 card" style="margin:0;padding: 20px 10px;">
                    <div class="cv2-toolbar">
                      <div class="cv2-search">
                        <i class="ph ph-magnifying-glass"></i>
                        <input type="text" class="fv2-field-input" [(ngModel)]="catClassTable.search" (ngModelChange)="catClassTable.onSearch()" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
                      </div>
                      <select class="fv2-field-input cv2-size" [(ngModel)]="catClassTable.size" (ngModelChange)="catClassTable.onSize()" [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let n of catClassTable.sizes" [ngValue]="n">{{ n }}</option>
                      </select>
                    </div>
                <div class="fv2-wrap">
                <table id="category-detail-view-table" class="fv2-table">
                  <thead>
                    <tr><th class="fv2-th-sort" (click)="catClassTable.sort('ClassName')">{{ 'className' | translate }} <i class="ph" *ngIf="catClassTable.sortKey === 'ClassName'" [ngClass]="catClassTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="catClassTable.sort('TotalSection')">{{ 'numberOfSections' | translate }} <i class="ph" *ngIf="catClassTable.sortKey === 'TotalSection'" [ngClass]="catClassTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="catClassTable.sort('TotalStudent')">{{ 'totalStudents' | translate }} <i class="ph" *ngIf="catClassTable.sortKey === 'TotalStudent'" [ngClass]="catClassTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th>{{ 'view' | translate }}</th></tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="loading('getCategoryClassListService')"><tr class="cv2-skel-row" *ngFor="let _r of skel(4)"><td *ngFor="let _c of skel(4)"><span class="cv2-skel"></span></td></tr></ng-container>
                    <tr *ngIf="classlistbycat.length > 0 && catClassTable.filtered.length === 0 && !loading('getCategoryClassListService')"><td colspan="4" class="cv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                    <tr *ngFor="let categoryclass of view(catClassTable, classlistbycat)" [rowEntrance]="categoryclass"
                      (click)="categoryClassDetailView(categoryclass.ClassName,categoryclass.TotalSection,categoryclass.TotalStudent,categoryclass.classId)">
                      <td #className class="fv2-money">{{categoryclass.ClassName}}</td>
                      <td #totalSections>{{categoryclass.TotalSection}} {{ 'sections' | translate }}</td>
                      <td #totalStudents>{{categoryclass.TotalStudent}}</td>
                      <td>
                        <button (click)="offcanvasviewclass(categoryclass,classId.innerText)" class="offcanvasviewclass fv2-btn-ghost"><i class="ph ph-arrow-square-out"></i><span>{{ 'viewClass' | translate }}</span></button>
                        <span #classId style="display:none">{{categoryclass.classId}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
                    <div class="cv2-pager" *ngIf="catClassTable.filtered.length > 0">
                      <span class="cv2-pager-info">{{ catClassTable.filtered.length }} {{ 'total' | translate }}</span>
                      <div class="cv2-pager-btns">
                        <button type="button" class="fv2-btn-ghost" [disabled]="catClassTable.page <= 1" (click)="catClassTable.go(catClassTable.page - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
                        <b>{{ catClassTable.page }} / {{ catClassTable.pages }}</b>
                        <button type="button" class="fv2-btn-ghost" [disabled]="catClassTable.page >= catClassTable.pages" (click)="catClassTable.go(catClassTable.page + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
                      </div>
                    </div>
              </div>
            </div>
          </div>
          <!-- End Student details -->
        </div>
      </div>
      <!-- End view categories -->

      <!--Update class name-->
<div class="modal fade cv2-modal" id="edit-selected-category-class" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-buildings"></i></span>{{ 'editClassName' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <form class="form" role="form">
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'className' | translate }}</label><input type="text" class="form-control stdName" id="editCategoryCategoryClassName" [(ngModel)]="editCategoryCategoryClassName" name="className" [ngModelOptions]="{standalone: true}" value="{{classStandardName}}"></div>
        </form>
      </div>
      <div class="modal-footer">
        <button id="closeUpdateClass" type="button" class="fv2-btn-ghost" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
        <button type="button" id="classButton" class="fv2-btn-primary" (click)="updateClassName(updateClassStdName)">{{ 'update' | translate }}</button>
      </div>
    </div>
  </div>
</div>

      <!--End of update class-->
      <!-- View class canvas -->
      <div id="offcanvas-view-class" class="offcanvas-pane width-12" style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head cv2-oc-head" style="padding: 0;">
          <div class="cv2-oc-banner">
            <h3 class="cv2-oc-close" data-dismiss="offcanvas" role="button" aria-label="Close"><i class="ph ph-x"></i></h3>
            <p class="cv2-oc-eyebrow">{{ 'classDetails' | translate }}</p>
            <p class="cv2-oc-sub">{{ 'viewSelectedClassDetailsHere' | translate }}</p>
            <div class="fv2-stats cv2-oc-facts">
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-teal"><i class="ph ph-identification-card"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'className' | translate }}</span><b class="fv2-num">{{classStandardName}}</b></div></div>
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-sky"><i class="ph ph-squares-four"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'category' | translate }}</span><b class="fv2-num">{{getViewCatName}}</b></div></div>
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-maple"><i class="ph ph-users-three"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'cv2TotalSections' | translate }}</span><b class="fv2-num">{{getCategoryClassListtotalSections}}</b></div></div>
            </div>
          </div>
          <div class="cv2-oc-bar">
            <h4>{{ 'selectedClassDetails' | translate }}</h4>
            <button [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'" data-toggle="modal"
              data-target="#edit-selected-category-class" type="button" class="cv2-icon-btn" aria-label="Edit"><i class="ph ph-note-pencil"></i></button>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card" style="margin-bottom: 0; padding-bottom: 3em;">
                <div class="card-head">
                  <ul class="nav nav-tabs" data-toggle="tabs" style="padding: 0;cursor: pointer">
                    <li class="active"><a data-target="#students-tab" data-toggle="tab">{{ 'students' | translate }}</a></li>
                    <li *ngIf="(permissions.ADD_CLASSES == 'ENABLED' || permissions.VIEW_CLASS_SECTIONS == 'ENABLED')">
                      <a data-target="#sections-tab" data-toggle="tab">{{ 'sections' | translate }}</a>
                    </li>
                    <li *ngIf="(permissions.ADD_SUBJECT == 'ENABLED' || permissions.VIEW_SUBJECTS == 'ENABLED')"><a
                        data-target="#subjects-tab" data-toggle="tab">{{ 'subjects' | translate }}</a></li>
                    <li *ngIf="(permissions.ADD_CLASSES == 'ENABLED' || permissions.VIEW_CLASS_SECTIONS == 'ENABLED')">
                      <a data-target="#staffs-tab" data-toggle="tab" (click)="openClassTeacherAssign()">{{ 'classTeacher' | translate }}</a>
                    </li>
                  </ul>
                </div><!--end .card-head -->
                <div class="card-body tab-content">
                  <!-- Students -->
                  <div class="tab-pane active" id="students-tab">
                    <form class="form-inline text-center search-groups" autocomplete="off"
                      style="margin-top: -1em;margin-bottom: 2em;">
                      <div class="form-group">
                        <h4 style="color: #6b6b6b;font-weight: 300;"> {{ 'sortStudentsBy' | translate }} </h4>
                      </div>
                      <div class="form-group">
                        <select class="form-control" id="selectedsection"
                          (change)="selectcategoryViewClassSection($event)">
                          <option value="0">{{ 'selectSection' | translate }}</option>
                          <option *ngFor="let section of getClassViewClassSectionArray"
                            value="{{section.claaSectionId}}">
                            {{section.className}} - {{section.classSection}}</option>
                        </select>
                      </div>
                      <button type="button" id="viewstud" class="fv2-btn-primary"
                        (click)="ViewstudentListClassSection()">{{ 'viewStudents' | translate }}</button>
                    </form>
                    <div id="class-detail-student-detail-tab">
                      <div *ngIf="!studentListClassSectionStatus">
                    <div class="cv2-toolbar">
                      <div class="cv2-search">
                        <i class="ph ph-magnifying-glass"></i>
                        <input type="text" class="fv2-field-input" [(ngModel)]="studentTable.search" (ngModelChange)="studentTable.onSearch()" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
                      </div>
                      <select class="fv2-field-input cv2-size" [(ngModel)]="studentTable.size" (ngModelChange)="studentTable.onSize()" [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let n of studentTable.sizes" [ngValue]="n">{{ n }}</option>
                      </select>
                    </div>
                        <div class="fv2-wrap">
                        <table id="view-class-detail-student-table" class="fv2-table">
                          <thead>
                            <tr><th class="fv2-th-sort" (click)="studentTable.sort('studentName')">{{ 'cv2StudentName' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'studentName'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="studentTable.sort('rollNumber')">{{ 'cv2RollNumber' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'rollNumber'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="studentTable.sort('parentName')">{{ 'cv2ParentName' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'parentName'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="studentTable.sort('mobileNumber')">{{ 'cv2MobileNumber' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'mobileNumber'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="studentTable.sort('dateOfBirth')">{{ 'cv2DateOfBirth' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'dateOfBirth'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="studentTable.sort('gender')">{{ 'cv2Gender' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'gender'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th><th class="fv2-th-sort" (click)="studentTable.sort('isAppUser')">{{ 'cv2IsAppUser' | translate }} <i class="ph" *ngIf="studentTable.sortKey === 'isAppUser'" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i></th></tr>
                          </thead>
                          <tbody>
                            <ng-container *ngIf="loading('getStudentListClassSection')"><tr class="cv2-skel-row" *ngFor="let _r of skel(6)"><td *ngFor="let _c of skel(7)"><span class="cv2-skel"></span></td></tr></ng-container>
                            <tr *ngIf="getClassSectionStudentListArray.length > 0 && studentTable.filtered.length === 0 && !loading('getStudentListClassSection')"><td colspan="7" class="cv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                            <tr *ngFor="let student of view(studentTable, getClassSectionStudentListArray)" [rowEntrance]="student">
                              <td class="fv2-money">{{student.studentName}}</td>
                              <td>{{student.rollNumber}}</td>
                              <td>{{student.parentName}}</td>
                              <td>{{student.mobileNumber}}</td>
                              <td>{{student.dateOfBirth | date: 'yMMMd'}}</td>
                              <td>{{student.gender == 1 ? 'Male':'Female'}}</td>
                              <td>{{student.isAppUser == 1 ? 'Active':'Inactive'}}</td>
                            </tr>
                          </tbody>
                        </table>
                        </div>
                    <div class="cv2-pager" *ngIf="studentTable.filtered.length > 0">
                      <span class="cv2-pager-info">{{ studentTable.filtered.length }} {{ 'total' | translate }}</span>
                      <div class="cv2-pager-btns">
                        <button type="button" class="fv2-btn-ghost" [disabled]="studentTable.page <= 1" (click)="studentTable.go(studentTable.page - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
                        <b>{{ studentTable.page }} / {{ studentTable.pages }}</b>
                        <button type="button" class="fv2-btn-ghost" [disabled]="studentTable.page >= studentTable.pages" (click)="studentTable.go(studentTable.page + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
                      </div>
                    </div>
                      </div>
                      <div *ngIf="studentListClassSectionStatus" id="studentList" class="row col-md-12 text-center">
                        <h3>{{ 'noStudentsAreAssignedToThisClass' | translate }}</h3>
                      </div>
                    </div>
                  </div>
                  <!--edit section-->
                  <div id="editSectionModal-opener" data-toggle="modal" data-target="#editSectionModal"></div>
<div class="modal fade cv2-modal" id="editSectionModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-squares-four"></i></span>{{ 'editSectionName' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <form class="form" role="form">
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'className' | translate }}</label><input type="text" class="form-control" id="editSectionClassName" [(ngModel)]="getSectionNameInClass" [ngModelOptions]="{standalone: true}"></div>
        <div class="form-group cv2-field"><label class="fv2-field-label">{{ 'category' | translate }}</label><select id="cat" name="class lead" class="form-control" [(ngModel)]="sectionDetail.categoryId" (change)="selectcategoryAddSection($event.target.value)">
            <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">{{category.categoryName}}</option>
          </select></div>
        </form>
      </div>
      <div class="modal-footer">
        <button id="closeupdatesection" type="button" class="fv2-btn-ghost" data-dismiss="modal">{{ 'cancel' | translate }}</button>
        <button type="button" id="updateSec" class="fv2-btn-primary" (click)="UpdateSectionInStdView(getSectionNameInClass)">{{ 'update' | translate }}</button>
      </div>
    </div>
  </div>
</div>
                  <!--edit section ends-->
                  <!--delete section modal-->
                  <div id="deletesectionmodal-opener" data-toggle="modal" data-target="#deletesectionmodal"></div>
<div class="modal fade cv2-modal" id="deletesectionmodal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-trash"></i></span>{{ 'deleteSection' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <p class="cv2-confirm">{{ 'areYouConfirmToDeleteTheSection' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button id="deletepopupclose" class="fv2-btn-ghost" data-dismiss="modal">{{ 'cancel' | translate }}</button>
        <button (click)="deleteSectionInStdView()" class="fv2-btn-primary cv2-btn-danger">{{ 'ok' | translate }}</button>
      </div>
    </div>
  </div>
</div>
                  <!--end of delete section modal-->
                  <!-- Sections -->
                  <div class="tab-pane" id="sections-tab">
                    <div id="section-List" [style.display]="!enableSectionSequence ? '':'none'">
                      <div class="cv2-sec-head" [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'">
                        <button type="button" class="fv2-btn-ghost" (click)="initiateSectionOrder()"><i class="ph ph-sort-ascending"></i><span>{{ 'cv2OrderSections' | translate }}</span></button>
                        <button type="button" class="fv2-btn-primary" [class.hidden]="addNewSectionStatus" (click)="classViewAddNewSection()"><i class="ph ph-plus"></i><span>{{ 'addNew' | translate }}</span></button>
                      </div>
                      <div class="cv2-inline-add" [class.hidden]="!addNewSectionStatus">
                        <div class="cv2-inline-add-row">
                          <div class="cv2-inline-add-field">
                            <label class="fv2-field-label" for="cv2-new-section">{{ 'cv2SectionName' | translate }}</label>
                            <input class="fv2-field-input" id="cv2-new-section" type="text" [(ngModel)]="getNewSectionName" [ngModelOptions]="{standalone: true}">
                          </div>
                          <button id="addSectionButton" type="button" class="fv2-btn-primary" (click)="classViewAddNewSectionProcess()">{{ 'addSection' | translate }}</button>
                          <button type="button" class="fv2-btn-ghost" (click)="classViewAddNewSectionCancel()">{{ 'cancel' | translate }}</button>
                        </div>
                      </div>
                      <div class="fv2-wrap">
                        <table class="fv2-table">
                          <thead>
                            <tr>
                              <th>{{ 'cv2SectionName' | translate }}</th>
                              <th class="cv2-th-right">{{ 'cv2ManageSection' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody class="add-section-table">
                            <ng-container *ngIf="loading('getClassSectionListService','viewStandardListSection')"><tr class="cv2-skel-row" *ngFor="let _r of skel(3)"><td *ngFor="let _c of skel(2)"><span class="cv2-skel"></span></td></tr></ng-container>
                            <tr *ngIf="getClassViewClassSectionArray.length === 0 && !loading('getClassSectionListService','viewStandardListSection')"><td colspan="2" class="cv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                            <tr *ngFor="let section of getClassViewClassSectionArray" [rowEntrance]="section">
                              <td>
                                <span class="cv2-section-label">{{ 'cv2Section' | translate }}</span>
                                <span #sectionName class="cv2-section-pill">{{section.classSection}}</span>
                              </td>
                              <td class="cv2-th-right">
                                <a [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                                  style="cursor:pointer;" class="btn btn-flat ink-reaction section-manage"
                                  (click)="editSectionPopup();classViewSectionName(sectionName.innerText,sectionId.innerText,classStdId.innerText);getClassCategories();sectionDetails()"><i
                                    class="fa fa-edit"></i></a>
                                <a [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                                  style="cursor:pointer;" class="btn btn-flat ink-reaction section-manage"
                                  (click)="deleteSectionPopup();classViewSectionName(sectionName.innerText,sectionId.innerText,classStdId.innerText)"><i
                                    class="fa fa-trash"></i></a>
                                <span #sectionId style="display: none;">{{section.claaSectionId}}</span><span #classStdId
                                  style="display: none">{{section.fkClassStandardsId}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-12 text-center" id="sectionOrder-Status"
                      style="display: none;height: 100%;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding-top: 10em;">
                      <img src="images_ext/default.gif">
                      <h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>{{ 'pleaseWait' | translate }}</h3>
                    </div>
                    <div *ngIf="enableSectionSequence">
                      <div class="cv2-sec-head cv2-sec-head-title">
                        <h3>{{ 'cv2UpdateSectionOrder' | translate }}</h3>
                      </div>
                      <div class="fv2-wrap">
                        <table class="fv2-table">
                          <thead>
                            <tr>
                              <th>{{ 'cv2Order' | translate }}</th>
                              <th>{{ 'cv2SectionName' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody id="sequence-SectionList" class="add-section-table list">
                            <tr *ngFor="let section of getClassViewClassSectionArray; let i = index">
                              <td><input class="fv2-field-input cv2-order-input" type="text"
                                  [(ngModel)]="section.SectionSequence" [ngModelOptions]="{standalone: true}" (keyup)="validateSectionOrder(section, i)" /></td>
                              <td>
                                <span class="cv2-section-label">{{ 'cv2Section' | translate }}</span>
                                <span #sectionName class="cv2-section-pill">{{section.classSection}}</span>
                                <span class="sectionId" #sectionId style="display: none;">{{section.claaSectionId}}</span><span #classStdId
                                  style="display: none">{{section.fkClassStandardsId}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="cv2-sec-foot">
                        <button type="button" (click)="enableSectionSequence = false" class="fv2-btn-ghost cancelSectionorder">{{ 'cancel' | translate }}</button>
                        <button type="button" class="fv2-btn-primary" (click)="updateSectionOrder()">{{ 'save' | translate }}</button>
                      </div>
                    </div>
                  </div>

                  <!-- Subjects -->
                  <div class="tab-pane" id="subjects-tab">
                    <div class="row col-md-12">
                      <div class="col-md-6">
                        <form class="form-inline text-center search-groups" autocomplete="off"
                          style="margin-top: -1em;margin-bottom: 2em;">
                          <div class="form-group">
                            <select id="selectSectionId" class="form-control">
                              <option value="0">{{ 'selectSection' | translate }}</option>
                              <option *ngFor="let section of getClassViewClassSectionArray"
                                value="{{section.claaSectionId}}">{{section.className}} - {{section.classSection}}
                              </option>
                            </select>
                          </div>
                          <button type="button" id="viewSub" class="fv2-btn-primary"
                            (click)="viewSubject()">{{ 'viewSubject' | translate }}</button>
                        </form>
                      </div>
                      <div [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'"
                        class="col-md-6 text-center" style="margin-top: 1em;">
                        <div id="addSubject">
                          <h4 style="color: #6b6b6b;font-weight: 300;display: inline-block;margin-right: 10px;"> {{ 'wantToAddMoreSubjectsToClass' | translate }} </h4>
                          <button type="button" (click)="addMoreSubjectsToClass()"
                            class="fv2-btn-primary">{{ 'add' | translate }}</button>
                          <div id="open-assign-subject-to-class-popup" data-toggle="modal"
                            data-target="#assign-subject-to-class-popup"></div>
                        </div>
                        <div id="addNewSubject" style="display: none">
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-content text-left">
                                <input type="text" class="form-control" id="groupbutton9"
                                  [(ngModel)]="addSub.subjectname" name="addSubject">
                                <label for="groupbutton9" style="margin-top: -10px;">{{ 'subjectName' | translate }}</label>
                              </div>
                              <div class="input-group-btn">
                                <button id="addSub" class="fv2-btn-primary" type="button"
                                  (click)="addNewSubject(addSub)">{{ 'addSubject' | translate }}</button>
                                <button id="canceladdSubject" class="fv2-btn-ghost" type="button"
                                 >{{ 'cancel' | translate }}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 cv2-skel-block" id="subject-Status" style="display: none;">
                      <div class="cv2-skel cv2-skel-line"></div><div class="cv2-skel cv2-skel-line"></div><div class="cv2-skel cv2-skel-line"></div>
                    </div>
                    <table id="subject-table" class="fv2-table">
                      <thead>
                        <tr>
                          <th class="col-md-4">{{ 'subjectName' | translate }}</th>
                          <th class="col-md-5"><span>{{ 'allottedStaffs' | translate }}</span></th>
                          <th class="col-md-2">{{ 'assign/viewStudent' | translate }}</th>
                          <!--<th class="col-md-1">Total Student</th>-->
                          <th class="col-md-1">{{ 'remove' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody class="add-subject-table">
                        <ng-container *ngIf="loading('fetchSubjectListandStaff')"><tr class="cv2-skel-row" *ngFor="let _r of skel(4)"><td *ngFor="let _c of skel(4)"><span class="cv2-skel"></span></td></tr></ng-container>
                        <tr *ngFor="let sub of subjectList;let i = index">
                          <td>{{sub.subject}}</td>
                          <td>
                            <div class="cv2-staff-cell">
                              <div class="cv2-chips" *ngIf="sub.staffList && sub.staffList.length > 0">
                                <span *ngFor="let staf of sub.staffList" class="cv2-chip tag label label-info">{{staf.staffName}}<button type="button" class="cv2-chip-x" aria-label="Remove" (click)="unAssignStaffFromSubject(staf)"><i class="ph ph-x"></i></button></span>
                              </div>
                              <input [style.display]="sub.inClass ? '':'none'" type="text" id="searchStaff"
                                name="search-staff" (change)="searchstaffForsubject(sub)" class="fv2-field-input"
                                [(ngModel)]="sub.searchData" [ngModelOptions]="{standalone: true}" placeholder="Search staff to assign">
                              <div class="cv2-staff-results" *ngIf="sub.stafList && sub.stafList.length > 0">
                                <div class="cv2-staff-card" id="search-staff_{{sub.subjectId}}"
                                  *ngFor="let staff of sub.stafList" (click)="assignSubjectToStaff(staff,sub)">
                                  <img src="{{staff.staffImage}}" class="img-circle" alt="staff" width="40" height="40">
                                  <div>
                                    <h4 class="staff-Name">{{staff.staffName}}</h4>
                                    <p class="designation">{{staff.designation}}</p>
                                    <p class="mob-number">{{staff.mobileNumber}}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="text-center"><a class="btn btn-flat ink-reaction"
                              (click)="getStudentListOfSubjectAssign(sub.subjectId)"
                              data-target="#assignSubjectToStudentPopup" data-toggle="modal">
                              <i class="md md-assignment"></i></a>
                          </td>
                          <!--<td>3</td>-->
                          <td class="text-center">
                            <a (click)="assignsubjectinclass(sub,false,i)"
                              *ngIf="!sub.isLoading && permissions.ADD_SUBJECT == 'ENABLED'"
                              class="btn btn-flat ink-reaction">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                            <i *ngIf="sub.isLoading" class="fa fa-spinner fa-spin"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Staffs -->
                  <div class="tab-pane" id="staffs-tab">
                    <div class="row col-md-12">
                      <div class="col-md-6">
                        <form class="form-inline text-center search-groups" autocomplete="off"
                          style="margin-top: -1em;margin-bottom: 2em;">
                          <div class="form-group">
                            <select id="selectSection" class="form-control">
                              <option value="0">{{ 'selectSection' | translate }}</option>
                              <option *ngFor="let section of getClassViewClassSectionArray"
                                value="{{section.claaSectionId}}">{{section.className}} - {{section.classSection}}
                              </option>
                            </select>
                          </div>
                          <button id="viewTeacher" type="button" class="fv2-btn-primary"
                            (click)="viewTeacher()">{{ 'viewClassTeacher' | translate }}</button>
                        </form>
                      </div>
                      <div [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'" class="col-md-6"
                        style="text-align: center;margin-top: 10px;">
                        <div id="addTeacher" style="display: none">
                          <h4 style="color: #6b6b6b;font-weight: 300;display: inline-block;margin-right: 10px;"> {{ 'wantToAddMoreClassTeacherInThisClass' | translate }} </h4>
                          <button type="button" (click)="editClassTeacher = null"
                            class="fv2-btn-primary" data-toggle="modal"
                            data-target="#add-class-teacher-popup" id="addnewteacher">{{ 'addNew' | translate }}</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 cv2-skel-block" id="classTeacher-Status" style="display: none;">
                      <div class="cv2-skel cv2-skel-card"></div><div class="cv2-skel cv2-skel-card"></div>
                    </div>
                    <div>
                      <div id="classTeacherList" class="col-md-12">
                        <div class="cv2-teacher-card" *ngFor="let teacher of teacherList">
                          <div class="cv2-teacher-main">
                            <img src="{{teacher.staffImage}}" class="img-circle" alt="staff" width="56" height="56">
                            <div>
                              <h4 class="staff-Name">{{teacher.staffName}}</h4>
                              <p class="designation">{{teacher.designation}}</p>
                              <p class="mob-number">{{teacher.mobileNumber}}</p>
                            </div>
                          </div>
                          <span class="cv2-chip cv2-chip-status" [class.on]="teacher.isAppUser != 0">{{teacher.isAppUser == 0 ? 'Inactive' : 'Active'}} {{ 'inBluewingsApp' | translate:{ brandName: brand.name } }}</span>
                          <div class="cv2-teacher-perm">
                            <label class="fv2-field-label">{{'feeAccessInClassTeacherView' | translate}}</label>
                            <div class="cv2-seg">
                              <button type="button"
                                (click)="updateStaffPermissionForFeeAccess(teacher.staffId, true); teacher.isStaffHasPermissionToViewStudentFees = true; $event.stopPropagation();"
                                [class.on]="teacher.isStaffHasPermissionToViewStudentFees"><i class="fa fa-check"></i> {{'enable' | translate}}</button>
                              <button type="button"
                                (click)="updateStaffPermissionForFeeAccess(teacher.staffId, false);teacher.isStaffHasPermissionToViewStudentFees = false; $event.stopPropagation();"
                                [class.on]="!teacher.isStaffHasPermissionToViewStudentFees"><i class="fa fa-times"></i> {{'disable' | translate}}</button>
                            </div>
                          </div>
                          <div [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'" class="cv2-teacher-actions">
                            <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#add-class-teacher-popup" (click)="editclassTeacherPopUp(teacher)">
                              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </a>
                            <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#remove-teacher"
                              (click)="removeclassTeacherPopUp(teacher.staffId,teacher.position)"
                              *ngIf="(teacher.position+1) == teacherList.length">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div id="noClassTeacher" class="col-md-12 text-center" style="display: none">
                        <h4>{{ 'thereAreNoClassTeachersAssignedForThisClass' | translate }}</h4>
                      </div>
                      <!--<div id="addNewClassTeacher"  class="row col-md-12 text-center card" style="height: 6em;display: none">
                        <div class="col-md-10 col-md-offset-2">
                          <input type="text" class="form-control" id="search-staff-assign" [(ngModel)]="teacher.searchTeacher"  name="searchTeacher" placeholder="Search staff for assign in this class" style="width: 80%;margin-top: 15px;">
                        </div>
                      </div>
                      <div id="stdTeacherList">
                        <div class="row col-md-12 card" *ngFor="let stafs of staffsList" id="search-teacher_{{stafs.staffId}}" (click)="assignClassTeacher(stafs)" style="margin: 0px;cursor: pointer">
                          <div class="col-md-4">
                            <img src="{{stafs.staffImage}}" class="img-circle" alt="staff" width="60" height="60" style="margin-top: 10px;">
                          </div>
                          <div class="col-md-8">
                            <h4 class="staff-Name">{{stafs.staffName}}</h4>
                            <p class="designation" style="margin-top: -15px;">{{stafs.designation}}</p>
                            <p class="mob-number" style="margin-top: -20px;">{{stafs.mobileNumber}}</p>
                          </div>
                        </div>
                      </div>-->
                    </div><!--end .card -->
                  </div>

                  <!-- time table -->
                  <div class="tab-pane" id="timetable-tab">
                    <form class="form-inline text-center search-groups" autocomplete="off">
                      <div class="form-group">
                        <label for="select13" class="control-label">{{ 'selectSection' | translate }}</label>
                        <select id="select13" name="select13" class="form-control">
                          <option value="">{{ 'selectOption' | translate }}</option>
                          <option value="section A">{{ 'sectionA' | translate }}</option>
                          <option value="section B">{{ 'sectionB' | translate }}</option>
                          <option value="section C">{{ 'sectionC' | translate }}</option>
                          <option value="section D">{{ 'sectionD' | translate }}</option>
                        </select>
                        <div class="form-control-line"></div>
                      </div>

                      <!-- <button type="submit" class="btn btn-raised btn-default-light ink-reaction">View Students</button> -->
                      <button type="button" class="fv2-btn-primary">{{ 'viewTimetable' | translate }}</button>
                      <!-- <button type="button" class="btn btn-raised ink-reaction btn-default-bright">Add Timetable</button> -->
                      <button type="button" class="fv2-btn-primary" data-toggle="modal"
                        data-target="#add-new-timetable">{{ 'addTimetable' | translate }}</button>

                    </form>


                  </div>
                </div><!--end .card-body -->
              </div>
            </div><!--end .card -->
          </div>

        </div>
      </div>
      <!-- End view class canvas -->
      <!-- View Subject details -->
      <div id="offcanvas-view-classsubjects" class="offcanvas-pane width-12"
        style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head cv2-oc-head" style="padding: 0;">
          <div class="cv2-oc-banner">
            <h3 class="cv2-oc-close" data-dismiss="offcanvas" role="button" aria-label="Close"><i class="ph ph-x"></i></h3>
            <p class="cv2-oc-eyebrow">{{ 'subjectDetails' | translate }}</p>
            <p class="cv2-oc-sub">{{ 'viewSelectedSubjectDetailsHere' | translate }}</p>
            <div class="fv2-stats cv2-oc-facts">
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-teal"><i class="ph ph-identification-card"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'subjectName' | translate }}</span><b class="fv2-num">{{getViewsubjectName}}</b></div></div>
              <div class="fv2-stat"><span class="fv2-stat-icon fv2-t-sky"><i class="ph ph-squares-four"></i></span><div class="fv2-stat-text"><span class="fv2-label">{{ 'cv2TotalClasses' | translate }}</span><b class="fv2-num">{{getViewsubjectBelonging}}</b></div></div>
            </div>
          </div>
          <div class="cv2-oc-bar">
            <h4>{{ 'selectedSubjectBelongingClasses' | translate }}</h4>
            <button [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'" data-toggle="modal"
              data-target="#updateSubject" type="button" class="cv2-icon-btn" aria-label="Edit"><i class="ph ph-note-pencil"></i></button>
          </div>
          <div class="cv2-oc-body">
            <div class="fv2-panel">
              <div class="fv2-details-head">
                <h3>{{ 'cv2ClassesInSubject' | translate }}</h3>
                <span class="cv2-count">{{ getSubjectListViewArray.length }}</span>
              </div>
              <ul class="cv2-class-list">
                <li class="cv2-class-row" *ngIf="loading('schoolClassManagementGetSubjectListView')"><div class="cv2-skel cv2-skel-line"></div></li>
                <li class="cv2-class-row" *ngIf="loading('schoolClassManagementGetSubjectListView')"><div class="cv2-skel cv2-skel-line"></div></li>
                <li class="cv2-class-row" *ngIf="loading('schoolClassManagementGetSubjectListView')"><div class="cv2-skel cv2-skel-line"></div></li>
                <li class="cv2-class-row" *ngFor="let subjectclassview of getSubjectListViewArray" [rowEntrance]="subjectclassview">
                  <span class="cv2-class-icon"><i class="ph ph-chalkboard-teacher"></i></span>
                  <span class="cv2-class-name">{{subjectclassview.className}}</span>
                  <span class="cv2-section-pill">{{ 'section' | translate }} {{subjectclassview.classSection}}</span>
                </li>
              </ul>
              <div class="cv2-empty-cell" id="unavailSub" style="display: none;">{{ 'thereAreNoAnyClassesExistInThisSubject' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End view categories -->
    </div>
    <!-- End of Off Canvas -->
  </div><!--end #base-->
  <!-- END BASE -->
  <!--Remove Class Teacher-->
<div class="modal fade cv2-modal" id="remove-teacher" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-trash"></i></span>{{ 'delete' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <p class="cv2-confirm">{{ 'areYouConfirmToRemoveClassTeacherFromThisClass' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeremoveTeacherpopup" class="fv2-btn-ghost" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
        <button type="button" class="fv2-btn-primary cv2-btn-danger" (click)="removeTeacherFromClass()">{{ 'delete' | translate }}</button>
      </div>
    </div>
  </div>
</div>
  <!--Remove Class Teacher-->
  <!--start deleteuser-->
<div class="modal fade cv2-modal" id="action-message" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-clock"></i></span>{{ 'changeTimeTableConfiguration' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <p id="action-message-info" class="cv2-confirm"></p>
      </div>
      <div class="modal-footer">
        <button id="closeTimeTableConfig" class="fv2-btn-ghost" (click)="configButtonShow()" data-dismiss="modal">{{ 'cancel' | translate }}</button>
        <button (click)="changeTimeTableConfig()" class="fv2-btn-primary">{{ 'ok' | translate }}</button>
      </div>
    </div>
  </div>
</div>
  <!--end delete user-->

  <!--start add subjects to the class-->
<div class="modal fade cv2-modal" id="assign-subject-to-class-popup" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-book-open"></i></span>{{ 'cv2AddSubjectsToClass' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close"><i class="ph ph-x"></i></button>
      </div>
      <div class="modal-body">
        <div *ngIf="isProcessing" class="text-center"><i class="fa fa-spinner fa-spin"></i></div>
        <div class="text-center cv2-muted" *ngIf="subjectListNotInClass.length == 0 && !isProcessing">{{ 'noMoreSubjectsToAdd' | translate }}</div>
        <form class="form cv2-check-grid">
          <div class="checkbox checkbox-styled" *ngFor="let s of subjectListNotInClass; let i = index">
            <label>
              <input type="checkbox" (change)="assignsubjectinclass(s,true,i)" [disabled]="s.inClass"
                [(ngModel)]="s.inClass" name="{{'sub_'+s.subjectId}}">
              <span title="{{s.subject}}">{{truncateText(s.subject,9)}}</span>
            </label>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button (click)="subjectListNotInClass.length > 0 ? viewSubject() : ''" data-dismiss="modal" class="fv2-btn-primary">{{ 'done' | translate }}</button>
      </div>
    </div>
  </div>
</div>
  <!--end add subjects to the class-->

  <!--start add subjects to the class-->
<div id="add-class-teacher-popup" class="modal fade cv2-modal" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-chalkboard-teacher"></i></span>{{ 'cv2AssignClassTeacher' | translate }}</h4>
          <button aria-hidden="true" id="close-assign-class-teacher-popup" class="close" data-dismiss="modal" type="button"><i class="ph ph-x"></i></button>
        </div>
        <div class="modal-body">
          <input type="text" class="form-control" id="search-staff-assign" name="searchTeacher"
            placeholder="Search Class Teachers/ Co-ordinate's" (input)="selectedStaff = null">
          <div *ngIf="isProcessing" class="text-center"><i class="fa fa-spinner fa-spin"></i></div>
          <div *ngIf="!isProcessing && staffsList.length > 0" [className]="staffsList.length == 0 ? 'hide' :'cv2-staff-list'">
            <div class="cv2-staff-card" *ngFor="let stafs of staffsList" id="search-teacher_{{stafs.staffId}}"
              (click)="selectStaff(stafs)" [class.selected]="selectedStaff?.staffId === stafs.staffId">
              <img src="{{stafs.staffImage}}" class="img-circle" alt="staff" width="48" height="48">
              <div>
                <h4 class="staff-Name">{{stafs.staffName}}</h4>
                <p class="designation">{{stafs.designation}}</p>
                <p class="mob-number">{{stafs.mobileNumber}}</p>
              </div>
            </div>
          </div>
          <div *ngIf="selectedStaff" class="cv2-staff-perm">
            <label class="cv2-label">{{'feesAccessToStaff' | translate}}</label>
            <div class="cv2-seg">
              <button type="button" (click)="isStaffHasPermissionToViewStudentFees = true; $event.stopPropagation();"
                [class.on]="isStaffHasPermissionToViewStudentFees"><i class="fa fa-check"></i> {{'enable' | translate}}</button>
              <button type="button" (click)="isStaffHasPermissionToViewStudentFees = false; $event.stopPropagation();"
                [class.on]="!isStaffHasPermissionToViewStudentFees"><i class="fa fa-times"></i> {{'disable' | translate}}</button>
            </div>
          </div>
        </div>
        <div class="modal-footer" *ngIf="selectedStaff">
          <button type="button" class="fv2-btn-primary cv2-btn-primary"
            (click)="assignClassTeacher(selectedStaff, isStaffHasPermissionToViewStudentFees)">{{'addBtnText' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <!--end add subjects to the class-->

  <!--ASSIGN SUBJECT TO STUDENT MODEL START-->
  <div class="modal fade" id="assignSubjectToStudentPopup" tabindex="-1" role="dialog"
    aria-labelledby="simpleModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width: 85%;">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"><span class="cv2-modal-icon"><i class="ph ph-book-open"></i></span>{{ 'assignSubject' | translate }}
            <small class="cv2-muted">{{ 'assignSubjectToStudentHere' | translate }}</small></h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ph ph-x"></i></button>
        </div>
        <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
          <div class="row">
            <div class="col-md-12" style="padding: 1em 2em;">
              <div id="studentListForAssignSubject">
                <div *ngIf="studentAssignStatus"
                  style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                  <div class="col-md-12" style="text-align: center;">
                    <img src="assets/img/search_icon_animation.gif" style="width: 300px;">
                    <h3 style="margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'pleaseWait' | translate }}</h3>
                  </div>
                </div>
                <div *ngIf="studentAssignNoData" class="col-md-12 text-center" style="color: teal;padding-top: 5em;">
                  <h3>{{ 'thereAreNoAnyStudentInThisClass' | translate }}</h3>
                </div>
                <div *ngIf="studentAssignData" class="table-responsive">
                  <table id="assignSubjectStudentTable" class="fv2-table">
                    <thead>
                      <tr>
                        <th class="text-center">
                          <label class="checkbox checkbox-styled" style="height: 10px;">
                            <input type="checkbox" [(ngModel)]="selectAllForAssignStudent"
                              (change)="applyAllForAssignStudent()" name="applyToAllStudent">
                            <span>{{ 'selectAll' | translate }}</span>
                          </label>
                        </th>
                        <th>{{ 'cv2StudentName' | translate }}</th>
                        <th>{{ 'cv2RollNumber' | translate }}</th>
                        <th>{{ 'cv2ParentName' | translate }}</th>
                        <th>{{ 'cv2MobileNumber' | translate }}</th>
                        <th>{{ 'cv2DateOfBirth' | translate }}</th>
                        <th>{{ 'cv2Gender' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let student of studentListForSubject">
                        <td class="text-center">
                          <label class="checkbox checkbox-styled" style="height: 10px;">
                            <input type="checkbox" [(ngModel)]="student.studentSubjectStatus"
                              (change)="checkAllSelected()" name="{{'applyToStudent'+student.studentId}}">
                            <span>&nbsp;</span>
                          </label>
                        </td>
                        <td style="padding-left: 10px;">{{student.studentName}}</td>
                        <td style="padding-left: 10px;">{{student.rollNumber}}</td>
                        <td style="padding-left: 10px;">{{student.parentName}}</td>
                        <td style="padding-left: 10px;">{{student.mobileNumber}}</td>
                        <td style="padding-left: 10px;">{{student.dateOfBirth | date: 'yMMMd'}}</td>
                        <td style="padding-left: 10px;">{{student.gender == 1 ? 'Male':'Female'}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-md-12 text-center" style="padding: 10px 15px;">
                    <button type="button" id="assignSubjectToStudentButton" (click)="assignSubjectToStudent()"
                      class="fv2-btn-primary">{{ 'save' | translate }} </button>
                  </div>
                </div><!--end .table-responsive -->
              </div>
            </div>
          </div>
        </div>
        <!--<div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
          <div class="col-md-6">
            <p style="color: #717171;"><span style="color: red;">*</span> Internal Exam: Marks will not be included in report card</p>
          </div>
          &lt;!&ndash;<div class="col-md-4">
            <p style="color: #717171;">© 2017 {{ brand.name }}. All right reserved</p>
          </div>&ndash;&gt;
          <div class="col-md-6">
            <p style="color: #717171;"><span style="color: red">*</span> External Exam: Marks will be included in report card</p>
          </div>

        </div>-->
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <!--ASSIGN SUBJECT TO STUDENT MODEL END-->

  <!--End of Error collecting Fee-->

  <app-timetable-time-clash-v2 *ngIf="openTimetableTimeClashPopup" (save_button_event)="removeTimeSlot()"
    (closePopup)="cancelAction()" [visible]="openTimetableTimeClashPopup ? 'block' : 'none'"
    [fullMessageHTMLString]="fullMessageHTMLString" [showTimeSlot]="showTimeSlotClashed" [showClass]="showClassClashed"
    [staffImage]="staffImageClashed"></app-timetable-time-clash-v2>

  <!--End Of Status-->
</div>








<!-- start modal for remove slot-->

<!--<div id="removetimeslotmodal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content" style="margin-top: 190px">
      <div class="modal-body">
        <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times" style="color:var(--secondary-btn-bg-color);"></i> Remove Time Slot</h3>
        <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;" type="button">×</button>
        <div class="col-md-3" style="width: 150px;min-height: 150px;margin: 0 auto;">
          <img src="{{staffImageToRemoveTimeSlot}}" id="staffimageforttimetble" style="margin-top: 43px;height: 80px;width: 80px;" class="img-responsive">
        </div>
        &lt;!&ndash;<div class="col-md-9">&ndash;&gt;
          <p id= "showmsg" style="font-size: 19px;margin-left: 6px;padding: 29px 30px;"></p>
        &lt;!&ndash;</div>&ndash;&gt;
        <p style="margin-top: -2em;font-size: 19px;margin-left: 99px;padding: 29px 30px;">Do you want to clear <span class="text-bold">{{showTimeslot}}</span> period in <span class="text-bold">{{showClass}}</span>?</p>
        <div style="padding:0px 205px;margin-top: -12px;">
          <button (click)="removeTimeSlot()" class="btn btn-info btn-sm" style="width: 67px;">YES</button>
          <button id="removetimeslot" class="btn btn-info btn-sm" data-dismiss="modal">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!-- end modal for remove slot-->

<div class="fv2-modal-backdrop cv2-confirm-backdrop" *ngIf="showGlobalAttendanceConfirmModal" (click)="closePopup()">
  <div class="fv2-modal cv2-confirm-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <div class="fv2-modal-head">
      <h3><i class="ph ph-user-check"></i> {{'attendanceConfiguration' | translate}}</h3>
      <button type="button" class="fv2-modal-close" (click)="closePopup()" aria-label="Close"><i class="ph ph-x"></i></button>
    </div>
    <div class="fv2-modal-body">
      <p>{{'globalAttendanceSwitchMessage'| translate}}</p>
    </div>
    <div class="fv2-modal-foot">
      <button type="button" class="fv2-btn-ghost" (click)="closePopup()">{{'cancel' | translate}}</button>
      <button type="button" class="fv2-btn-primary" [disabled]="globalAttendanceLoader" (click)="handleGlobalAttendanceSwitch()">
        <ng-container *ngIf="globalAttendanceLoader; else notLoading">
          <app-button-loader></app-button-loader>
        </ng-container>
        <ng-template #notLoading>
          <span>{{'switch' | translate}}</span>
        </ng-template>
      </button>
    </div>
  </div>
</div>